$( document ).ready(function() {
    $('.c-mm-login form').submit(function(e) {
      e.preventDefault();
      var form = $(this);
      var url = form.attr('action');
      console.log("Form action URL:", url);

      $(".c-mm-login .modal-submit").addClass("loading");
      $(".c-mm-login .modal-submit-button-text").text("PROCESSING");

      $(".c-mm-login input").removeClass("has-error");
      $(".c-mm-login .error-container").text("");

      $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(), // serializes the form's elements.
        success: function(response){
          var errors =  $(response).find(".errors").text();

          if(errors && errors.length > 0){
            $(".c-mm-login").find('[name="customer[email]"]').addClass("has-error");
            $(".c-mm-login").find('[name="customer[password]"]').addClass("has-error");
            $(".c-mm-login").find('.password-error-container').text("Incorrect email or password");
            $(".c-mm-login .modal-submit").removeClass("loading");
            $(".c-mm-login .modal-submit-button-text").text("SUBMIT");
          } else {
            $('.member-popup-container-pdp').fadeOut('fast');
                window.fetch("/cart/update.js", {
                    method: "POST"
                })
                .then(() => {
                    document.dispatchEvent(new CustomEvent("theme:cartchanged", { bubbles: true }));
                    $('.cart-member-club').removeClass('active');
                    document.querySelector("body").classList.remove("popup-open");
                    document.querySelector("[data-section-type='header']").classList.remove("hidden-visibility");
                })
                .then(() => {
                    // Reload the page only after cart update is complete
                    location.reload();
                })
                .catch((error) => {
                    console.error('Error updating cart:', error);
                    $(".c-mm-login .modal-submit").removeClass("loading");
                    $(".c-mm-login .modal-submit-button-text").text("SUBMIT");
                });
          }
        }
      });
    })

  /* Create account script */
  $('.c-mm-signup form').submit(function(e) {
      e.preventDefault();
      var form = $(this);
      var url = form.attr('action');

     var captchaResponse = grecaptcha.getResponse();
    
    if (!captchaResponse) {
        alert('Please complete the CAPTCHA');
        return;
    }

      $(".c-mm-signup .modal-submit").addClass("loading");
      $(".c-mm-signup .modal-submit-button-text").text("PROCESSING");

      $(".c-mm-signup input").removeClass("has-error");
      $(".c-mm-signup .error-container").text("");

      $.ajax({
        type: "POST",
        url: url,
        data: form.serialize() + '&g-recaptcha-response=' + captchaResponse, // serializes the form's elements.
        success: function(response){
					console.log("testing")
          console.log($(response).find(".errors").text())
          var errors =  $(response).find(".errors").text();

          if(errors && errors.length > 0){
            console.log("Failed")
						console.log(errors);
            $(".c-mm-signup").find('.password-error-container').text(errors);
            $(".c-mm-signup .modal-submit").removeClass("loading");
            $(".c-mm-signup .modal-submit-button-text").text("SUBMIT");
          } else {
            $.ajax({
							type: "POST",
							url: $('.c-mm-login form').attr('action'),
							data: `form_type=customer_login&utf8=%E2%9C%93&${$(".c-mm-signup .input-row").find('[name="customer[email]"]').serialize()}&${$(".c-mm-signup .input-row").find('[name="customer[password]"]').serialize()}`, 
							success: function(response){
								var errors =  $(response).find(".errors").text();
								
								console.log('errors', errors)

								if(errors && errors.length > 0){
									console.log("Failed")
									console.log(errors)
								} else {
									$('.member-popup-container-pdp').fadeOut('fast');
                                     location.reload();
								}
							}
						});
          }
        }
      });
    })

  $('.c-mm-reset form').submit(function(e) {
      e.preventDefault();
      var form = $(this);
      var url = form.attr('action');

      $(".c-mm-reset .modal-submit").addClass("loading");
      $(".c-mm-reset .modal-submit-button-text").text("PROCESSING");

      $(".c-mm-reset input").removeClass("has-error");
      $(".c-mm-reset .error-container").text("");

      $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(), // serializes the form's elements.
        success: function(response){
          var errors =  $(response).find(".errors").text();

          if(errors && errors.length > 0){
            $(".c-mm-reset").find('[name="email"]').addClass("has-error");
            $(".c-mm-reset .modal-submit").removeClass("loading");
            $(".c-mm-reset .modal-submit-button-text").text("SUBMIT");
          } else {
            // $('.member-popup-container-pdp').fadeOut('fast');
            // location.reload();
            $(".c-mm-reset .success-message").removeClass("hidden-success");
          }
        }
      });
    });
  
})